
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ci-primary",attrs:{"fill":"#0fb0e1","d":"M440 16H80a24.028 24.028 0 00-24 24v432a24.028 24.028 0 0024 24h360a24.028 24.028 0 0024-24V40a24.028 24.028 0 00-24-24zm-8 448H88v-96h344zm0-128H88V48h344z"}}),_c('path',{staticClass:"ci-primary",attrs:{"fill":"#0fb0e1","d":"M232 400h32v32h-32z"}})])
          )
        }
      }
    